const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
}

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
}

const layoutModeTypes = {
  DARK: "dark",
  LIGHT: "light",
}

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
}

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
}

const leftSidebarTypes = {
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
}

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
}

const partnerImageTypes = {
  DEFAULT: "small_img",
  COMPACT: "large_img",
  ICON: "icon",
}

/** Global UI font scale — Current matches today's default size */
const fontScaleTypes = {
  SMALL: "sm",
  CURRENT: "md",
  LARGE: "lg",
}

/** Font families already shipped in project styles. */
const fontFamilyTypes = {
  POPPINS: "poppins",
  ROBOTO: "roboto",
  OPEN_SANS: "open-sans",
}

/** App UI theme — Current keeps existing look; Modern/Dark restyle sidebar + tables */
const uiThemeTypes = {
  CURRENT: "current",
  MODERN: "modern",
  DARK: "dark",
}

/**
 * Global body text color for readability.
 * Current = theme default (#495057); Charcoal / Soft Navy = higher-contrast alternatives.
 * RED key keeps stored "red" value; UI shows Deep Teal (#05555d).
 * PRIMARY = original primary navy (#0d1b6e).
 * DEEP_SAPPHIRE = rich royal blue (#1e3a8a).
 * DEEP_MAROON = warm wine maroon (#7a1f2e).
 * DEEP_BLACK = near-black (#0a0a0a).
 */
const fontColorTypes = {
  CURRENT: "current",
  CHARCOAL: "charcoal",
  SOFT_NAVY: "soft-navy",
  RED: "red",
  PRIMARY: "primary",
  DEEP_SAPPHIRE: "deep-sapphire",
  DEEP_MAROON: "deep-maroon",
  DEEP_BLACK: "deep-black",
}

const FONT_SCALE_STORAGE_KEY = "app-font-scale"
const FONT_FAMILY_STORAGE_KEY = "app-font-family"
const FONT_COLOR_STORAGE_KEY = "app-font-color"
const UI_THEME_STORAGE_KEY = "app-ui-theme"

export {
  layoutTypes,
  layoutModeTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  partnerImageTypes,
  fontScaleTypes,
  fontFamilyTypes,
  fontColorTypes,
  uiThemeTypes,
  FONT_SCALE_STORAGE_KEY,
  FONT_FAMILY_STORAGE_KEY,
  FONT_COLOR_STORAGE_KEY,
  UI_THEME_STORAGE_KEY,
}
